// 导入组件，组件必须声明 name
import AceUpload from "./src/main";
import AceFileReview from "./src/views/FileReview.vue";
// 为组件添加 install 方法，用于按需引入
AceUpload.install = function (Vue) {
  Vue.component(AceUpload.name, AceUpload);
};
AceFileReview.install = function (Vue) {
  Vue.component(AceFileReview.name, AceFileReview);
};
export { AceUpload, AceFileReview };
